(() => {
  const DESKTOP_MIN_WIDTH = 750;

  function resetDesktop(root = document) {
    const accordions = root.querySelectorAll('.footer-menu-mobile-accordion');

    accordions.forEach((accordion) => {
      accordion.classList.add('is-open');

      const content = accordion.querySelector('.accordion-content');
      const header = accordion.querySelector('.accordion-header');

      if (content) {
        content.classList.add('open');
        content.style.maxHeight = null;
      }

      if (header) {
        header.setAttribute('aria-expanded', 'true');
      }
    });
  }

  function resetMobile(root = document) {
    const accordions = root.querySelectorAll('.footer-menu-mobile-accordion');

    accordions.forEach((accordion) => {
      accordion.classList.remove('is-open');

      const content = accordion.querySelector('.accordion-content');
      const header = accordion.querySelector('.accordion-header');

      if (content) {
        content.classList.remove('open');
        content.style.maxHeight = null;
      }

      if (header) {
        header.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function applyResponsiveState(root = document) {
    if (window.innerWidth >= DESKTOP_MIN_WIDTH) {
      resetDesktop(root);
      return;
    }

    resetMobile(root);
  }

  function bindAccordions(root = document) {
    const headers = root.querySelectorAll('.accordion-header');

    headers.forEach((header) => {
      if (header.dataset.footerAccordionBound === 'true') {
        return;
      }

      header.dataset.footerAccordionBound = 'true';

      header.addEventListener('click', () => {
        if (window.innerWidth >= DESKTOP_MIN_WIDTH) {
          return;
        }

        const accordion = header.closest('.footer-menu-mobile-accordion');
        const content = header.nextElementSibling;
        const isOpen = accordion && accordion.classList.contains('is-open');

        if (!accordion || !content) {
          return;
        }

        document.querySelectorAll('.footer-menu-mobile-accordion').forEach((item) => {
          const itemContent = item.querySelector('.accordion-content');
          const itemHeader = item.querySelector('.accordion-header');

          item.classList.remove('is-open');

          if (itemContent) {
            itemContent.classList.remove('open');
            itemContent.style.maxHeight = null;
          }

          if (itemHeader) {
            itemHeader.setAttribute('aria-expanded', 'false');
          }
        });

        if (!isOpen) {
          accordion.classList.add('is-open');
          content.classList.add('open');
          content.style.maxHeight = `${content.scrollHeight}px`;
          header.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initFooterAccordion(root = document) {
    bindAccordions(root);
    applyResponsiveState(root);
  }

  document.addEventListener('DOMContentLoaded', () => {
    initFooterAccordion();

    window.addEventListener('resize', () => {
      applyResponsiveState();
    });
  });

  document.addEventListener('shopify:section:load', (event) => {
    initFooterAccordion(event.target);
  });
})();
